module.exports = __webpack_public_path__ + "img/lab-icon.a3118608.svg";